import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import stateMap from "store/stateMap";
import "./style.scss";
import api from "api";

const ComponentPageLike = connect(stateMap)((props) => {
    const [totalLike, setTotalLike] = useState(false);
    const [isLiked, setIsLiked]     = useState(null);
    const [liking, setIsLiking]     = useState(false);
    const SwitchLike = (e) => {
        e.preventDefault();

        setIsLiking(true);

        api( '/PageLikes', 'post', {
            group_id : props.page.PageID
        }, 'Bearer ' + props.auth.token).then(response => {
            setTotalLike(response.likes);  

            setIsLiked(!isLiked);

            setIsLiking(false);
        })
        .catch(() => {
            setIsLiking(false);
        })
    }

    useEffect(() => {
        
        if(props.page)
        {
            api( '/PageLikes', 'get', {
                group_id : props.page.PageID
            }, props.auth.token ? 'Bearer ' + props.auth.token : '').then(response => {
                setTotalLike(response.total_like);

                setIsLiked(response.like_it);
            })
            .catch(() => {

            })
        }

    }, [props.auth.user, props.page]);

    return (
        <div className="page-like-component">
            <span className="total-liked">{totalLike} Likes</span>
            {
                liking && <span className="btn btn-like btn-small">Like...</span>
            }
            {
                props.auth.user && !liking && isLiked === true &&
                <button className="btn btn-primary btn-like btn-small" onClick={SwitchLike}>Liked</button>
            }
            {
                props.auth.user && !liking && isLiked === false &&
                <button className="btn btn-primary btn-like btn-small" onClick={SwitchLike}>Like</button>
            }
        </div>
    )
})

export default ComponentPageLike;